export var EDropdownDirection;

(function (EDropdownDirection) {
  EDropdownDirection[EDropdownDirection["Up"] = 0] = "Up";
  EDropdownDirection[EDropdownDirection["Down"] = 1] = "Down";
})(EDropdownDirection || (EDropdownDirection = {}));

export var getDropdownDirection = function getDropdownDirection(container, popup) {
  var containerRect = container.getBoundingClientRect();
  var popupHeight = popup.clientHeight;
  var spaceAtTheTop = containerRect.top - popupHeight;
  var spaceAtTheBottom = document.documentElement.clientHeight - containerRect.top - containerRect.height - popupHeight;

  if (spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom) {
    return EDropdownDirection.Up;
  }

  return EDropdownDirection.Down;
};